import { IframeProxy } from '@namespace/cms';
import { Pandascore } from '../../common/OneEvent/Pandascore';

export const PandascoreIframeProxy = () => {
  return <IframeProxy Component={Pandascore} />;
};
